import styled from "styled-components";

export const SelectCompaniesModalWrapper = styled("form")(() => {
  return {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "calc(var(--flexGap))",
    "& legend": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "24px",
      textAlign: "center",
      paddingInline: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& select": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) / 2)",
      outline: "none",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      borderRadius: ".45rem",
      fontWeight: "400",
    },
    "& .action-buttons-row": {
      gap: "calc(var(--flexGap)/3)",
      "& div": {
        flex: 1,
        overflow: "hidden",
      },
      "& span": {
        display: "inline-block",
        width: "100%",
      },
      "@media screen and (max-width: 550px)": {
        flexDirection: "column",
      },
    },
    "& .cancel-button": {
      backgroundColor: "var(--color-button-secondary)",
      color: "var(--color-text)",
      border: "1px solid var(--color-primary)",
    },
  };
});
